export default __webpack_public_path__ + "b97d52feab5f2340ee96bd570541c2e2.png";